import axios from 'axios'
import { CADASTRAR_TOMADOR } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function cadastrarCupom (comandoTomador) {
    return dispatch => axios.post(`${URL}/tomador/cadastrar`, comandoTomador, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_TOMADOR,
        payload: response.data
      })
    )
  }
